import { FolderPlus, X } from "lucide-react";

const CreateProjectHeader = ({ onClose }) => {
  return (
    <div className="flex items-start justify-between border-b border-slate-200 bg-white px-6 py-5">

      <div className="flex items-center gap-4">

        <div className="rounded-xl bg-blue-100 p-3">
          <FolderPlus
            size={24}
            className="text-blue-600"
          />
        </div>

        <div>
          <h2 className="text-2xl font-bold text-slate-800">
            Create New Project
          </h2>

          <p className="mt-1 text-sm text-slate-500">
            Create and configure a new project
          </p>
        </div>

      </div>

      <button
        type="button"
        onClick={onClose}
        className="rounded-lg p-2 text-slate-500 transition hover:bg-slate-100 hover:text-slate-800"
      >
        <X size={22} />
      </button>

    </div>
  );
};

export default CreateProjectHeader;